import { render, staticRenderFns } from "./liveList.vue?vue&type=template&id=fa657c3c&scoped=true"
import script from "./liveList.vue?vue&type=script&lang=js"
export * from "./liveList.vue?vue&type=script&lang=js"
import style0 from "./liveList.vue?vue&type=style&index=0&id=fa657c3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa657c3c",
  null
  
)

export default component.exports